// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://terramare.com";
export const CDN_BASE_URL = "https://cdn.terramare.com";
export const CART_BASE_URL = "https://cart.terramare.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6058022107001";
export const ONE_SHOPPING_CART_URL = "https://www.1shoppingcart.com";
export const LEGAL_BASE_URL = "https://legal.terramare.com";
export const PHONE_NUMBER_WITHOUT_AREA_CODE = "936-9261";
export const PHONE_NUMBER_AREA_CODE = "800";
export const FREE_SHIPPING_OVER_AMOUNT = "$50";
export const BRAND_NAME = "Terra Mare";

// External Service URLs
export const EXTERNAL_URLS = {
  PAYPAL_BUTTON: "assets/img/paypalButton.jpg",
  PAYPAL_BUTTON_LARGE: "assets/img/paypalButton-lg.jpg"
};

// CDN Image URLs
export const CDN_IMAGES = {
  BLUE_CHECK: `${CDN_BASE_URL}/images/blue_check.png`,
  BODY: `${CDN_BASE_URL}/images/gundry-body.png`,
  BRAND_LOGO: `${CDN_BASE_URL}/images/TerraMare-logo-dark.png`,
  GRAY_CHECK: `${CDN_BASE_URL}/images/gray_check2.png`,
  LOGO: `${CDN_BASE_URL}/images/TerraMare-logo-dark.png`,
  LOGO_WHITE: `${CDN_BASE_URL}/images/TerraMare-logo-white.png`,
  MBG: `${CDN_BASE_URL}/images/MBG.png`,
  PALM_WAIT: `${CDN_BASE_URL}/images/palm_wait.svg`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  PRIVACY_POLICY: `${CDN_BASE_URL}/privacy-policy/`,
  TERMS_AND_CONDITIONS: `${CDN_BASE_URL}/terms-and-condition/`,
  UP_NO: `${CDN_BASE_URL}/images/upNo.jpg`,
  UP_NO_MOBILE: `${CDN_BASE_URL}/images/upNo_mobile.jpg`,
  UP_YES: `${CDN_BASE_URL}/images/upYes.jpg`,
  UP_YES_MOBILE: `${CDN_BASE_URL}/images/upYes_mobile.jpg`,
  WHY: `${CDN_BASE_URL}/images/white-brown-dog.jpg`,
};

export const LINK_PAGES = {
  CA_PRIVACY_NOTICE: `${LEGAL_BASE_URL}/privacy-policy#Additional-Information-for-California-Residents`,
  PRIVACY_POLICY: `${LEGAL_BASE_URL}/privacy-policy/`,
  REGISTER: `${CART_BASE_URL}/register/`,
  TERMS_AND_CONDITIONS: `${LEGAL_BASE_URL}/terms/`,
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
